// NOTE: to reenable form validation, see comments below and in the following files: FanClubPassword/Default.cshtml, fomo-password-form.js and fomo-password-protect-template.hbs

import { mapState, mapActions } from 'vuex'

export default {
  name: 'fomo-password-protect',
  props: {
    translatedFeErrorMsg: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isValid: null,
    inputValue: '',
    feErrorMsg: null,
    parsedUrl: new URL(window.location.href)
  }),
  computed: {
    ...mapState('global', ['isXPE']),
    ...mapState('booking', ['query']),
    scope() {
      return {
        isValid: this.isValid,
        inputValue: this.inputValue,
        setInputValue: (value) => this.inputValue = value,
        handleResponse: this.handleResponse,
        handleError: this.handleError,
        feErrorMsg: this.feErrorMsg
      }
    }
  },
  mounted() {
    if (!this.isXPE) {
      this.$nextTick(() => {
        this.checkURL()
        this.handleSiblings('hide')
      })
    }
  },
  watch: {
    inputValue(val) {
      this.validateInput(val)
    }
  },
  methods: {
    ...mapActions('booking', ['updateQuery']),
    checkURL() {
      const iataCode = this.parsedUrl.searchParams.get('IATA')
      if (iataCode) {
        const element = this.$el
        const form = element.querySelector('form')
        const textInput = form.querySelector('input[type="text"]')
        textInput.value = iataCode
        form.requestSubmit()
      }
    },
    handleSiblings(visibility) {
      const element = this.$el
      const pageElements = element.parentNode.children
      const siblings = Object.values(pageElements).filter((el) => el !== element)
      if (visibility === 'hide') {
        siblings.forEach((sibling) => {
          sibling.style.display = 'none'
          sibling.classList.add('fomo-hidden')
        })
      } else {
        element.classList.add('invisible')
        setTimeout(() => {
          element.style.display = 'none'
          siblings.forEach((sibling) => sibling.style.display = 'block')
        }, 500)
        setTimeout(() => {
          siblings.forEach((sibling) => sibling.classList.add('fomo-unhidden'))
        }, 1000)
      }
    },
    validateInput(input) {
      // ### Uncomment below to reenable form validation ###
      // this.isValid =  /^\d{7,}$/.test(input)
      // ### Remove below to reenable form validation ###
      this.isValid = /^(?!\s*$).+/.test(input)
    },
    handleResponse(response) {
      if (response.succeeded === true) {
        this.handleSiblings('show')
        this.populateURL()
      } else {
        this.handleError()
      }
    },
    populateURL() {
      const iataCode = this.$el.querySelector('input[type="text"]').value
      const promoCode = this.$el.querySelector('.promocode').value
      const newQuery = { ...this.query }
      newQuery.iataNumber = iataCode
      if (promoCode.length) newQuery.promotionCode = promoCode
      this.updateQuery({ query: newQuery })
      this.parsedUrl.searchParams.delete('IATA')
      Object.entries(newQuery).forEach((entry) => {
        if (entry[1] === null) return
        this.parsedUrl.searchParams.set(entry[0], entry[1])
      })
      history.pushState({}, '', this.parsedUrl.href)
    },
    handleError() {
      this.feErrorMsg = this.translatedFeErrorMsg
    }
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  }

}
